import React from 'react'

import Reflux from 'reflux-react-16'
import moment from 'moment'

import LoginStore from '../stores/LoginStore.js'
import LoginActions from '../actions/LoginActions.js'

import {Alert, Button, P, H5, Colors} from '../../src/components/UI/index.js'
import {formSpacing, FormStack, Input, VerificationCodeInput} from '../../src/components/UI/forms/index.js'
import LoginPopup from '../../src/components/login/LoginPopup.js'

import Setup2FA from '../../src/views/utils/Setup2FA.js'
import LoadingPage from '../../src/views/utils/LoadingPage.js'

export default class Login extends Reflux.Component {
    constructor(props) {
        super(props)

        this.initTime = moment()

        const interval = setInterval(() => {
            if (moment().diff(this.initTime, 'minutes') > 10) {
                window.location = '/koerier/login'
            }
        }, 10000)

        this.state = {
            email: '',
            password: '',
            loading: false,
            error: '',
            interval,
            timeLeftTillLoginSeconds: 0
        }

        this.store = LoginStore
    }

    componentDidMount() {
        const {history} = this.props

        document.title = 'Koerier - Login'

        this.emailInput?.focus()

        LoginActions.loggedIn((loggedIn) => {
            if (loggedIn) {
                history.push('/koerier')
            }
        })
    }

    componentWillUnmount() {
        super.componentWillUnmount.call(this)
        clearInterval(this.state.interval)
        this.state.checkTimeLeftInterval && clearInterval(this.state.checkTimeLeftInterval)
    }

    onSubmit(event) {
        event.preventDefault()
        this.setState({loading: true, error: ''})

        const {history} = this.props
        const {email, password} = this.state

        LoginActions.getAccounts(email, password, async (err, response) => {
            if (err) {
                this.setState({loading: false, error: err})
                return
            }

            if (response.code === 401) {
                const checkTimeLeft = () => {
                    const now = moment()
                    const notAllowedTill = moment(response.noLoginTill)

                    if (notAllowedTill.isAfter(now)) {
                        this.setState({timeLeftTillLoginSeconds: notAllowedTill.diff(now, 'seconds')})
                    } else {
                        this.setState({timeLeftTillLoginSeconds: 0})
                        clearInterval(interval)
                    }
                }

                checkTimeLeft()

                const interval = setInterval(checkTimeLeft, 1000)

                this.setState({loading: false, checkTimeLeftInterval: interval})

                return
            }

            this.setState({loading: false})

            const token = response.token
            const accounts = response.accounts
            const index = accounts.length > 1 ? await this.loginPopup.open(accounts) : 0
            const account = accounts[index]

            this.setState({resellerName: account.reseller})

            if (account.mfaRequired) {
                if (account.mfaEnabled) {
                    this.setState({loading: false, token, index, showMfa: true, mfaChoice: account.mfaMethod}, () => {
                        if (account.mfaMethod === 'email') {
                            this.mailMFACode()
                        }
                    })
                } else {
                    LoginActions.generateMFAKey(token, index, (err, key, recoveryCode) => {
                        if (err) {
                            this.setState({error: err})
                        } else {
                            this.setState({
                                loading: false,
                                token,
                                index,
                                setupMFA: true,
                                authenticatorAppEnabled: account.authenticatorAppEnabled,
                                authenticatorEmailEnabled: account.authenticatorEmailEnabled,
                                MFAKey: key,
                                firstTime2fa: true,
                                recoveryCode
                            })
                        }
                    })
                }
            } else {
                LoginActions.login(token, index, null, (err) => {
                    if (!err) {
                        history.push('/koerier')
                    } else {
                        this.setState({loading: false, error: err})
                    }
                })
            }
        })
    }

    mailMFACode(mfaEmail) {
        const {index, token} = this.state

        this.setState({setupMFA: false, showMfa: true, showSendMfaEmail: false})

        if (this.MfaEmailTimeout) {
            clearTimeout(this.MfaEmailTimeout)
        }

        LoginActions.mailMFACode(token, index, mfaEmail, (err) => {
            if (err) {
                this.setState({error: err})
            } else {
                this.setState({setupMFA: false, showMfa: true})
            }
        })

        this.MfaEmailTimeout = setTimeout(() => {
            this.setState({showSendMfaEmail: true})
        }, 10000)
    }

    reset2FA(event) {
        event.preventDefault()
        const {recoveryCodeInput, index, token} = this.state

        this.setState({error: '', loading: true})

        if (!recoveryCodeInput) {
            this.setState({error: 'Er is geen recovery code ingevuld.'})
            return
        }

        LoginActions.reset2FA(token, index, recoveryCodeInput, (err) => {
            if (err) {
                this.setState({error: err})
            } else {
                this.setState({successMessage: 'Reset gelukt. Log in om tweestapsverificatie opnieuw in te stellen.', recoverySuccess: true})
            }
            this.setState({loading: false})
        })
    }

    onSubmitCode(event) {
        event.preventDefault()

        this.setState({loading: true, error: ''})

        const {history} = this.props
        const {token, index, code, firstTime2fa} = this.state

        LoginActions.login(token, index, code, (err) => {
            if (!err) {
                if (!firstTime2fa) {
                    history.push('/koerier')
                } else {
                    this.setState({showRecoveryCode: true, loading: false, firstTime2fa: false, error: ''})
                }
            } else {
                this.setState({loading: false, error: err})
            }
        })
    }

    onClickForgotPassword() {
        const {branding} = this.state
        window.location.href = `https://${branding?.domain || 'app.veloyd.nl'}/wachtwoordvergeten`
    }

    render() {
        const {email, password, loading, error, timeLeftTillLoginSeconds, showMfa, MFAKey, recoveryCodeInput, setupMFA, showSendMfaEmail, showInsertRecoveryCode, recoveryCode, resellerName, firstTime2fa, showRecoveryCode, recoverySuccess, successMessage, mfaChoice, brandingLoading, branding} = this.state

        if (brandingLoading) {
            return <LoadingPage />
        }

        return (
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100vh', overflowY: 'auto'}}>
                <div style={{flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
                    <form style={{height: '100%', width: '100%', overflowY: 'auto'}} onSubmit={showMfa ? this.onSubmitCode.bind(this) : this.onSubmit.bind(this)}>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', height: '100%', overflowY: 'auto'}}>
                            <img style={{maxHeight: 128, maxWidth: 256, marginTop: 100, marginBottom: 48, objectFit: 'contain'}} src={branding?.mainLogo || '/images/VELOYDLOGO.png'} />

                            {!showMfa && !setupMFA &&
                                <FormStack style={{width: '90%', maxWidth: 400, marginBottom: formSpacing.rowGap}}>
                                    <Input
                                        noPlaceholder
                                        type='email'
                                        autoComplete='username'
                                        label='Emailadres'
                                        required={true}
                                        value={email}
                                        onChange={(event) => this.setState({email: event.target.value.toLowerCase().replace(/\s+/g, ''), error: ''})}
                                        ref={(ref) => this.emailInput = ref}
                                    />

                                    <Input
                                        noPlaceholder
                                        type='password'
                                        autoComplete='current-password'
                                        label='Wachtwoord'
                                        required={true}
                                        value={password}
                                        onChange={(event) => this.setState({password: event.target.value, error: ''})}
                                    />
                                </FormStack>
                            }

                            {setupMFA &&
                                <Setup2FA
                                    onContinue={(mfaChoice, mfaEmail) => {
                                        this.setState({mfaChoice, error: ''}, () => {
                                            if (mfaChoice === 'app') {
                                                this.setState({setupMFA: false, showMfa: true})
                                            } else if (mfaChoice === 'email') {
                                                this.mailMFACode(mfaEmail)
                                            }
                                        })
                                    }}
                                    MFAKey={MFAKey}
                                    email={email}
                                    resellerName={resellerName}
                                    branding={branding}
                                />
                            }

                            {!showInsertRecoveryCode && showMfa && !showRecoveryCode &&
                                <div style={{marginBottom: 24}}>
                                    <P style={{margin: 'auto', marginBottom: 24, width: '95%', textAlign: 'center'}}>
                                        Vul de verificatiecode in verkregen via {mfaChoice === 'app' && 'je authenticator app'}{mfaChoice === 'email' && 'e-mail'}.
                                    </P>
                                    <div>
                                        <VerificationCodeInput
                                            onChange={(codeArray) => {
                                                this.setState({code: codeArray.join('')})
                                            }}
                                        />
                                    </div>
                                </div>
                            }

                            {showRecoveryCode &&
                                <div style={{marginBottom: 24, width: '95%', marginLeft: 'auto', marginRight: 'auto'}}>
                                    <Alert style={{marginBottom: 24, marginLeft: 0, marginRight: 0}}>Activatie gelukt!</Alert>

                                    <P style={{maxWidth: 500, marginBottom: 24, textAlign: 'center'}}>Hieronder staat de recovery code die bij de actieve 2FA methode hoort. Deze recovery code kun je gebruiken om de tweestapsverificatie te resetten wanneer je geen toegang meer hebt tot je authenticator app of je e-mail.</P>

                                    <H5 style={{marginBottom: 24, textAlign: 'center'}}>Bewaar deze code goed!</H5>

                                    <P style={{textAlign: 'center'}}>
                                        {recoveryCode}
                                    </P>
                                </div>
                            }

                            {showInsertRecoveryCode && !recoverySuccess &&
                                <div>
                                    <P style={{marginBottom: 24}}>Vul hier de recovery code in om 2FA te resetten.</P>

                                    <Input
                                        style={{marginBottom: 24, width: '100%'}}
                                        label='Recovery code'
                                        value={recoveryCodeInput}
                                        onChange={(event) => this.setState({recoveryCodeInput: event.target.value})}
                                    />

                                    <Button
                                        variant='solid'
                                        color={branding?.color || Colors.brandColor}
                                        style={{margin: 'auto', width: '100%'}}
                                        onClick={this.reset2FA.bind(this)}
                                        label='Reset tweestapsverificatie'
                                    />

                                    <Button
                                        style={{marginTop: 24, width: '100%'}}
                                        variant='text'
                                        onClick={() => this.setState({showInsertRecoveryCode: false})}
                                        label='Terug'
                                    />
                                </div>
                            }

                            {successMessage && recoverySuccess &&
                                <div style={{minHeight: 36, width: '95%', marginLeft: 'auto', marginRight: 'auto'}}>
                                    <Alert style={{marginBottom: 24, marginLeft: 0, marginRight: 0}}>
                                        {successMessage}
                                    </Alert>

                                    <Button
                                        style={{margin: 'auto'}}
                                        variant='text'
                                        onClick={() => history.go(0)}
                                        label='Naar inloggen'
                                    />
                                </div>
                            }

                            {error &&
                                <Alert style={{marginBottom: 6, width: '90%', maxWidth: 400}} variant='danger'>{error}</Alert>
                            }

                            {timeLeftTillLoginSeconds > 0 && (
                                <Alert style={{marginBottom: 6, width: '90%', maxWidth: 400}} variant='danger'>Je kan pas weer inloggen over {timeLeftTillLoginSeconds} seconden</Alert>
                            )}

                            {!setupMFA && !showInsertRecoveryCode &&
                                <Button
                                    color={branding?.color || Colors.brandColor}
                                    style={{
                                        width: '90%',
                                        maxWidth: 400,
                                        marginTop: 12
                                    }}
                                    type='submit'
                                    loading={loading}
                                    disabled={timeLeftTillLoginSeconds > 0}
                                    label={firstTime2fa ? 'Activeer' : 'Inloggen'}
                                />
                            }

                            {showMfa && showSendMfaEmail && !showRecoveryCode && !showInsertRecoveryCode && (
                                <Button
                                    style={{marginTop: 24}}
                                    variant='text'
                                    onClick={this.mailMFACode.bind(this)}
                                    label='Email niet ontvangen? Stuur email nog een keer'
                                />
                            )}

                            {showMfa && !firstTime2fa && !showRecoveryCode && !showInsertRecoveryCode &&
                                <Button
                                    style={{marginTop: 24}}
                                    variant='text'
                                    onClick={() => this.setState({showInsertRecoveryCode: true})}
                                    label='Geen toegang tot verificatie code?'
                                />
                            }

                            {!showMfa && !setupMFA &&
                                <div style={{marginTop: 72}}>
                                    <Button
                                        style={{margin: 'auto'}}
                                        variant='text'
                                        onClick={this.onClickForgotPassword.bind(this)}
                                        label='Wachtwoord vergeten?'
                                    />
                                </div>
                            }
                        </div>

                        <LoginPopup ref={(ref) => this.loginPopup = ref} />
                    </form>
                </div>
            </div>
        )
    }
}
